import React, { FC } from 'react';
import {
  FaAlignLeft as AbstractIcon,
  FaFilm as VideoIcon,
  FaFile as PosterIcon,
  FaDatabase as DatasetsIcon,
} from 'react-icons/fa';
import styled from 'styled-components';
import { media } from '@morressier/ts';

import * as Styles from './styles';

const ButtonsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 1.5rem;
  ${media.medium`
    margin: 0;
  `}
`;

const ArticleContents: FC<{
  poster: MorressierPoster & { pdfUrl: string };
  authUserId?: string;
  videoRef: React.MutableRefObject<null>;
  posterRef: React.MutableRefObject<null>;
  abstractRef: React.MutableRefObject<null>;
  datasetsRef: React.MutableRefObject<null>;
}> = props => {
  const hasVideo = Boolean(props.poster.video_presentation?.playback_url);
  const hasPoster = Boolean(props.poster.pdfUrl);
  const hasAbstract = Boolean(
    props.poster.paper_abstract && props.poster.paper_abstract.length > 2,
  );
  const hasDataSets = Boolean(props.poster.additional_file_urls?.length);
  const articleContents = [
    {
      titleId: 'Video',
      disabled: !hasVideo,
      label: 'video',
      icon: VideoIcon,
      ref: props.videoRef,
    },
    {
      titleId: 'PDF',
      disabled: !hasPoster,
      label: 'PDF',
      icon: PosterIcon,
      ref: props.posterRef,
    },
    {
      titleId: 'Abstract',
      disabled: !hasAbstract,
      label: 'abstract',
      icon: AbstractIcon,
      ref: props.abstractRef,
    },
    {
      titleId: 'Datasets',
      disabled: !hasDataSets,
      label: 'datasets',
      icon: DatasetsIcon,
      ref: props.datasetsRef,
      quantity: props.poster.additional_file_urls?.length,
    },
  ];

  const focus = ref => {
    const headerOffset = 160;
    const elementPosition = ref.current.getBoundingClientRect().top + window.pageYOffset;
    const offsetPosition = elementPosition - headerOffset;
    window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
  };

  return (
    <ButtonsContainer>
      {articleContents.map(content => (
        <Styles.ContentButton
          onClick={() => focus(content.ref)}
          key={content.label}
          disabled={content.disabled}
          iconLeft={<content.icon />}
          iconRight={content.disabled ? null : <Styles.DownIcon />}
        >
          {content.quantity} {content.titleId}
        </Styles.ContentButton>
      ))}
    </ButtonsContainer>
  );
};

export default ArticleContents;
